import {eventSender} from "Lib/event-sender/event-sender";
import {speed} from "Lib/speed/speed";
import {isTouch} from "Lib/istouch/istouch";
import {onScreen} from "Lib/on-screen/on-screen";
import {showAuth} from "Lib/show-auth/show-auth";
import { copytext } from 'Lib/copy-text/copy-text';
import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { Popup } from 'Lib/popup/popup';
import 'Bem/site/ajax-form/ajax-form';
import "Lib/date-prototype/date-prototype";
// old
import {EksmoSwitchbox, EksmoRadiobox, EksmoSelectbox} from "Lib/old/old";

var oFavorites = {
    contBooks : $('#js-lk #js-favorite-books'),
    sControl : '.js-favorite-control',
    htmlControl : '<div class="js-favorite-control"><div class="icon"><svg><use xlink:href="#personal-garbage"></use></svg></div>Убрать из избранного</div>',
    deleteFavoriteBook: function(e){
        var $item = $(e).closest('.books__item');
        var format = $item.attr('data-format');
        var $type = format === 'el' ? 'products_electro' :  format === 'audio' ? 'products_audio' : 'products';

        if($item.length){
            var guid = $item.attr('data-guid');

            if(typeof guid === 'string' && guid.length){
                $.get('/ajax/like/add/', {type:$type, guid:guid}, function(data){
                    if(data.trim() === 'AUTH'){
                        showAuth();
                    }else{
                        data = $.parseJSON(data);
                        data = data[guid];

                        if(data.SELECTED !== 'Y'){
                            var $count = $('.menu-lk .js-favorites-count');
                            var v = $count.html();

                            v = Number(v);
                            v--;
                            $count.html(v);

                            $item.fadeOut(500, function(){
                                $(this).remove();
                                eventSender.eventFavoritesRemove($item.attr('data-id'));
                                eventSender.setWishListMD();
                            });
                        }
                    }
                })
            }
        }

    },
    addHTML:function(){
        $('#js-lk #js-favorite-books .books__item').each(function(){
            if($(oFavorites.sControl, this).length <= 0){
                var contrl = $(oFavorites.htmlControl).click(function(){
                    oFavorites.deleteFavoriteBook(this);
                });

                $(this).append(contrl);
            }else{
                $(this).on('click', oFavorites.sControl, oFavorites.deleteFavoriteBook);
            }
        });
    }
};

oFavorites.addHTML();

var $lk = $('#js-lk');
var $bornInput = $('#js-born-input');

$bornInput.each(function(){
    $(this).attr('data-old-value', $(this).val());
});

function setBornInput($input, y, m, d){
    y = parseInt(y);
    m = parseInt(m);
    d = parseInt(d);

    if($input.length && y && m && d){
        var dt = new Date(y, m - 1, d);

        $input.val(dt.getDate() + '.' + (dt.getMonth() + 1) + '.' + dt.getFullYear());
    }
}

function setBornDayItems($parent, y, m, d){
    y = parseInt(y);
    m = parseInt(m);
    d = parseInt(d);

    if($parent.length && y && m){
        var $d = $parent.find('#js-born-day').first();
        var $dCont = $d.find('.cont').first();

        if($d.length && $dCont.length){
            var htmlItemTemp = '<div class="item js-item js-item-temp js-active">День</div>';
            var htmlItem = '<div class="item js-item" data-value="{num}">{num}</div>';
            var qtyDays = new Date(y, m-1, 1).daysInMonth() || 0;

            if(qtyDays){
                $dCont.html('');
                $dCont.append(htmlItemTemp);

                for(let i = 1; i <= qtyDays; i++)
                    $dCont.append(htmlItem.replace(new RegExp('{num}', 'g'), i));

                if(d){
                    var $oldDay = $dCont.find('.js-item[data-value=' + d + ']');

                    if($oldDay.length){
                        $dCont.find('.js-item-temp').remove();
                        $oldDay.addClass('js-active');
                        setBornInput($parent.find($bornInput).first(), y, m, d);
                    }
                }

            }
        }
    }
}

function setBorn(id, dataValue){
    dataValue = parseInt(dataValue) || 0;

    if(id.length && dataValue){
        var $parent = $('#' + id).parent();
        var cActive = 'js-active';
        var sActive = '.' + cActive;
        var $y = $parent.find('#js-born-year').first();
        var $m = $parent.find('#js-born-month').first();
        var $d = $parent.find('#js-born-day').first();
        var y = parseInt($y.find(sActive).data('value') || 0);
        var m = parseInt($m.find(sActive).data('value') || 0);
        var d = parseInt($d.find(sActive).data('value') || 0);
        var $curBornInput = $parent.find($bornInput).first();
        var oldVal = $curBornInput.attr('data-old-value');

        $curBornInput.val(oldVal);

        if(id === 'js-born-year' || id === 'js-born-month'){
            if(y && m)
                setBornDayItems($parent, y, m, d);
        }else if(id === 'js-born-day'){
            if(d){
                if(y && m)
                    setBornInput($curBornInput, y, m, d);

                $d.attr('data-old-value', d);
            }
        }
    }
}

{
    const popup = new Popup('popup', document?.querySelector('.promocode-gift__promoсode'));
    const textPromocode = $('.promocode-gift__promocode').text().trim();

    function sendPromocodeDL(type) {
        eventSender.customDL({
                event: "eksmo",
                eventAction: type,
                eventCategory: "подарок от Литрес - Личный кабинет",
                eventLabel: textPromocode
            }
        )
    }

    onScreen($('.promocode-gift'), () => {
        sendPromocodeDL('view');
    });

    $('.promocode-gift .btn')
        .on('click', () => {
            sendPromocodeDL('click');
        });

    $('.promocode-gift__promocode-box').on('click', () => {
        copytext('.promocode-gift__promocode');

        if (getW() < eksmoBP.xsMax) {
            popup?.open();
        }

        sendPromocodeDL('copy');
    });
}

{ // Загрузка аватара
    var $btn = $lk.find('.js-lk-btn-avatar');
    var $input = $lk.find('#js-input-avatar');

    $input.on('change', function(){
        var $btnLoading = $lk.find('.js-lk-btn-avatar-loading');
        var $btnSuccess = $lk.find('.js-lk-btn-avatar-success');
        var $avatar = $lk.find('#js-avatar-pic');
        var urlPic = $(this)[0].files[0];
        var fd = new FormData();

        $btn.hide();
        $btnLoading.show();
        $btnSuccess.hide();

        fd.append('avatar', urlPic);
        $.ajax({
            url: '/personal/avatar.php',
            data: fd,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function(respond){
                respond = $.parseJSON(respond);

                if(!!respond.ERROR){
                    alert(respond.ERROR)
                }else{
                    $('.upload-avatar .picture').html('<div class="pic" style="background-image:url(' + respond.FILE + ');"></div>');
                    $('.menu-lk .picture').html('<div class="pic" style="background-image:url(' + respond.FILE + ');"></div>');
                    //$avatar.html('');
                    //$avatar.css({'background-image': 'url(' + respond.FILE + ')'});
                    $btn.hide();
                    $btnLoading.hide();
                    $btnSuccess.show();
                    setTimeout(function(){
                        $btn.show();
                        $btnLoading.hide();
                        $btnSuccess.hide();
                    }, 3000);
                }
            },
            error: function( jqXHR, textStatus, errorThrown ){
                console.log('ОШИБКИ AJAX запроса: ' + textStatus );
            }
        });
    });

    $btn.on('click', function(){
        $input.trigger('click');
    });
}

{ // Удаление аватара
    $('.js-lk-btn-avatar-delete').on('click', function(){
        var $btn = $lk.find('.js-lk-btn-avatar-delete');
        var $btnLoading = $lk.find('.js-lk-btn-avatar-delete-loading');
        var $btnSuccess = $lk.find('.js-lk-btn-avatar-delete-success');

        $btn.hide();
        $btnLoading.show();

        $.ajax({
            url: '/personal/avatar.php',
            cache: false,
            contentType: false,
            processData: false,
            type: 'DELETE',
            success: function(){
                $('.upload-avatar .picture').html('<div class="pic"><svg><use xlink:href="#user-round"></use></svg></div>');
                $('.menu-lk .picture').html('<div class="pic"><svg><use xlink:href="#user-round"></use></svg></div>');
                //$avatar.html('');
                //$avatar.css({'background-image': 'url(' + respond.FILE + ')'});
                $btnLoading.hide();
                $btnSuccess.show();

                setTimeout(function(){
                    $btn.show();
                    $btnSuccess.hide();
                }, 3000);
            },
            error: function( jqXHR, textStatus, errorThrown ){
                console.log('ОШИБКИ AJAX запроса: ' + textStatus );
            }
        });
    });
}

{
    $('body').on('click', '.bl-input-password-svg-box', function(){
        const $th = $(this);
        const cBlInputActive = 'bl-input-password-svg-box-active';

        if ($th.hasClass(cBlInputActive)){
            $th.find('.bl-input-password-svg use').attr('xlink:href', '#eye-high');
            $th.next().attr('type', 'password');
            $th.removeClass(cBlInputActive);
        } else {
            $th.find('.bl-input-password-svg use').attr('xlink:href', '#eye-crossed-out');
            $th.addClass(cBlInputActive);
            $th.next().attr('type', 'text');
        }
    });
}

// Привязка аккаунтов соц. сетей
/*
{
    var sAccParent = '.js-sn-account';
    var $accParent = $lk.find(sAccParent);

    if($accParent.length){
        var sLinkBindAcc = '.js-bind-sn-acc';
        var sLinkUnbindAcc = '.js-unbind-sn-acc';
        var sLinkUnbindAccStatus = '.js-unbind-sn-acc-status';

        function accBind(sn){
            if(sn.length){
console.log(' --- ПРИвязать аккаунт к соц сети sn(' + sn + ')');
            }
        }

        function accUnbind(sn){
            if(sn.length){
console.log(' --- ОТязать аккаунт от соц сети sn(' + sn + ')');
            }
        }

        $('body').on('click', '.js-bind-sn-acc', function(e){
            e.preventDefault();

            $(this).closest(sAccParent).find(sLinkBindAcc).hide();
            $(this).closest(sAccParent).find(sLinkUnbindAcc).show();
            $(this).closest(sAccParent).find(sLinkUnbindAccStatus).show();
            accBind($(this).data('sn'));
        });

        $accParent.on('click', sLinkUnbindAcc, function(e){
            e.preventDefault();

            $(this).closest(sAccParent).find(sLinkBindAcc).show();
            $(this).closest(sAccParent).find(sLinkUnbindAcc).hide();
            $(this).closest(sAccParent).find(sLinkUnbindAccStatus).hide();
            accUnbind($(this).data('sn'));
        });
    }
}*/

{
    const $formRole = $('.lk-card_form-role');

    $('.radio__input').on('change', function() {
        const text = $(this).val();

        $('.other-form').removeClass('other-form_active');
        $('.lk-card__input-role').val(text);

        if (text !== 'Другое') {
            $formRole.trigger('submit');
        }
    })

    $('.other-form_btn').on('click', function() {
        $formRole.trigger('submit');
    })

    $('.lk-card__input-other').on('change', function() {
      $('.other-form').addClass('other-form_active');
    })

    $('.other-form__cancel').on('click', function() {
        $('.other-form').removeClass('other-form_active');
    })

    $('.lk-card__input-other-span-edits').on('click', function() {
        $('.other-form').addClass('other-form_active');
    })

    $formRole.on('eksmoThisAjaxFormSuccess', function () {
        const $this = $(this);
        const $otherFormInput = $this.find('.other-form__input');
        const text = $otherFormInput.val();

        if (text && text !== 'Другое') {
            $otherFormInput.val(text);
            $this.find('.lk-card__input-span_other').text(`Другое (${text})`);
            $('.other-form').removeClass('other-form_active');
            $('.lk-card__input-other-span-edits').addClass('lk-card__input-other-span-edits_active');
        }

        $this.find('.ajax-form__response').css('display', 'none');
        $this.removeClass('ajax-form_success');
    });
}

{
    /* Редактирование о себе */
    const cContentAbout = '.content_about';
    const $contentAbout = $(cContentAbout);

    $contentAbout.on('click', '.content__about-btn-edits, .content__about-btn-cancel', function() {
        const $parent = $(this).closest(cContentAbout);

        $parent.find('.content__about-form').removeClass('ajax-form_success');
        $parent.find('.ajax-form__response').remove();
        $parent.toggleClass('content_about_active');
    })

    $contentAbout.on('eksmoThisAjaxFormSuccess', '.content__about-form', function () {
        const $this = $(this);
        const text = $this.find('.content__about-textarea').val();
        const $parent = $this.closest(cContentAbout);

        $parent.toggleClass('content_about_active');
        $parent.find('.content__about').text(text);
    });
}

{
    /* Добавление инпута ввода соцсети для подписок */

    $('.js-bind-sn-acc').on('click', function() {
        var $parent = $(this).closest('.js-sn-account');

        $parent.toggleClass('js-sn-account_active');
    })
}

{ // управление подписками
    $('.lk__subcription').on('eksmoThisAjaxFormSuccess', function (e, resText) {
        $.fancybox.open(`
            <div class="fancybox-content width600">
                <div class="lk__popup-subscriptions">
                    <svg class="lk__popup-subscriptions-icon"><use xlink:href="#check2"></use></svg>

                    <div class="lk__popup-subscriptions-title">Ваши подписки изменены</div>
                    <div class="lk__popup-subscriptions-text">Вы можете написать нам на почту: <a class="a a_orange" href="mailto:info@eksmo.ru">info@eksmo.ru</a> с пометкой "Отписка", если письмо пришло Вам по ошибке</div>
                </div>
            </div>
        `);

        $('.ajax-form__response').hide();
    });


    var $bookDeleteLink = $lk.find('.js-book-delete');
    var $sbsrbSwitchOnLink = $lk.find('.js-link-switch-all-on');
    var $sbsrbSwitchOffLink = $lk.find('.js-link-switch-all-off');
    var sCard = '.js-lk-card-switchboxes';
    var sSwitchboxes = '.js-lk-switchbox';
    var cLabelActive = 'js-active';

    function setSubsribe(id, dataValue, callback){
        var a_data = id.split('_');
        var $label = $('#' + id);
        var vendor = '';

        if($label.length){
            var $form = $label.closest('form');

            if($form.length)
                if(typeof $form.attr('data-vendor') === 'string' && dataValue)
                    vendor = $form.attr('data-vendor');
        }

        $.post('/ajax/subscribe/personal/', {ajax:'Y', type:a_data[0], id:a_data[1], value:dataValue?1:0, vendor:vendor}, function(data){
            data = $.parseJSON(data);

            if(typeof callback === 'function'){
                if(data.STATUS === 'Y')
                    callback(true);
                else if(data.STATUS === 'N')
                    callback(false);
            }
        });
    }

    $bookDeleteLink.on('click', function(){
        var $t = $(this);
        var guid = $t.attr('data-guid');

        if(typeof guid === 'string' && guid.length){
            var $that = $(this);

            $.post('/ajax/subscribe/personal/', {ajax:'Y', type:'LIST', id:guid, value:0}, function(data){
                data = $.parseJSON(data);

                if(data.STATUS === 'N'){
                    $that.parents('.line').fadeOut();
                }
            })
        }
    });

    $sbsrbSwitchOnLink.on('click', function(){
        $(this).parents(sCard).find(sSwitchboxes + ':not(.' + cLabelActive + ')').find('input[type=checkbox]').each(function(){
            $(this).prop({'checked': true});
            $(this).change();
        });
    });

    $sbsrbSwitchOffLink.on('click', function(){
        $(this).parents(sCard).find(sSwitchboxes + '.' + cLabelActive).find('input[type=checkbox]').each(function(){
            $(this).prop({'checked': false});
            $(this).change();
        });
    });

    EksmoSwitchbox(sSwitchboxes, setSubsribe);

    // $bookDeleteLink.tooltip();
}

// Избранное


EksmoRadiobox('.js-lk-gender-radiobox');
EksmoSelectbox('#js-born-month, #js-born-day, #js-born-year', setBorn);

{ // Авторам
    var $lkAuthorBlock = $(".lk-author");
    var $formsValid = $('.lk-form-common-data, .lk-form-address, .lk-form-pasport-data, .lk-form-documents, .lk-form-snils, .lk-form-bank-details');

    //Открываем нужный блок если есть хэш
    if(window.location.hash.length > 0){
        var $hashBlock = $('.lk-manuscript-block[data-num="' + window.location.hash.replace('#', '') + '"]');

        if ($hashBlock.length) {
            $('html, body').scrollTop($hashBlock.offset().top - 100);
            $hashBlock.find('.lk-manuscript-accordion-content').show();
            window.location.hash = '';
        }
    }

    // Валидация
    var validateParams = {
        //errorClass: "lk-error",
        onkeyup: false,
        onfocusout: false,
        ignore: [] //скрытые поля тоже отправляем (необходимо для selectbox)
    };

    // Переключение checkbox в блоке подтверждения резидентства РФ
    $lkAuthorBlock.on('change', 'input[name="resident"]', function () {
        var $this = $(this);
        var $btn = $this.closest('form').find('input[type="submit"]');

        if ($this.prop("checked")) {
            $btn.removeClass('btn_disabled');
        } else {
            $btn.addClass('btn_disabled');
        }
    });

    // Нажатие на кнопку "Сохранить" в блоке подтверждения резидентства РФ
    $lkAuthorBlock.on('click', '.js-lk-resident-btn:not(.btn_disabled)', function () {
        var $btn = $(this);
        var $form = $btn.closest('form');
        var formData = $form.serializeArray();
        var resident = 'RESIDENT_2';

        $btn.addClass('btn_disabled');

        if (formData.length > 0) {
            if (formData[0].value === 'on') {

                // Если резидентство подтверждено
                resident = 'RESIDENT_1';
            }
        }

        console.log('resident', formData, resident, $form);

        $form.on('eksmoThisAjaxFormSuccess', function (e, message) {
            console.log('eksmoThisAjaxFormSuccess', message);
            //$form.addClass('lk-form-disabled');
            //$form.find('input').prop('disabled', true);
            window.location.hash = '#' + $form.closest('.lk-manuscript-block').attr('data-num');
            window.location.reload(true);

        });
        $form.on('eksmoThisAjaxFormFail', function (e, message) {
            console.log('eksmoThisAjaxFormFail', message);
            $.fancybox.close();
            if (typeof message === 'string') {
                $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>"' + message + '"</p></div>');
            } else {
                $.fancybox.open('<div><p class="text text_c-gray">Ошибка связи с сервером</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
            }
            $btn.removeClass('btn_disabled');
        });
        /*$.post($form[0].action, {resident: resident})
            .done(function(data){
                console.log('ajax resident data before JSONparse', data);
                data = $.parseJSON(data);
                console.log('ajax resident data', data);

                if(typeof data.error !== 'undefined') {
                    // Ошибка от сервера
                    console.log('error');
                    $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>"' + data.error + '"</p></div>');
                    $btn.removeClass('btn_disabled');
                } else {
                    // Успешная отправка
                    console.log('success');
                    $form.addClass('lk-form-disabled');
                    $form.find('input').prop('disabled', true);
                }
            })
            .fail(function () {
                console.log('fail');
                $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
                $btn.removeClass('btn_disabled');
            });*/
    });

    // Изменение выбора оферты
    $lkAuthorBlock.on('change', 'form:not(.lk-form-submit) .js-lk-agreemant-input', function () {
        var $btn = $(this).closest('form').find('.js-lk-agreemant-btn');

        $btn.removeClass('btn_disabled');
    });

    // Нажатие на кнопку "Сохранить" в блоке выбора оферты
    $lkAuthorBlock.on('click', '.js-lk-agreemant-btn:not(.btn_disabled)', function () {
        var $btn = $(this);
        var $form = $btn.closest('form');
        var formData = $form.serializeArray();
        var licenseType = formData[0].value;

        $btn.addClass('btn_disabled');
        $form.addClass('lk-form-submit');

        console.log('agreemant', formData, licenseType);

        $form.on('eksmoThisAjaxFormSuccess', function (e, message) {
            console.log('eksmoThisAjaxFormSuccess', message);
            $form.closest('.lk-author-agreemant-form-block').html('<div class="lk-success-text text text_s24"><div class="lk-success-icon"></div>Спасибо! Договор оферты заключен!</div>');
            setTimeout(function(){
                window.location.reload(true);
            }, 3000);
        });
        $form.on('eksmoThisAjaxFormFail', function (e, message) {
            console.log('eksmoThisAjaxFormFail', message);
            $.fancybox.close();
            if (typeof message === 'string') {
                $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>"' + message + '"</p></div>');
            } else {
                $.fancybox.open('<div><p class="text text_c-gray">Ошибка связи с сервером</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
            }
            $btn.removeClass('btn_disabled');
        });

        /*$.post($form[0].action, {license_type: licenseType})
            .done(function(data){
                console.log('ajax agreemant data before JSONparse', data);
                data = $.parseJSON(data);
                console.log('ajax agreemant data', data);

                if(typeof data.error !== 'undefined') {
                    // Ошибка от сервера
                    console.log('error');
                    $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>"' + data.error + '"</p></div>');
                    $btn.removeClass('btn_disabled');
                } else {
                    // Успешная отправка
                    console.log('success');
                    $('.lk-author-agreemant-form-block').html('<div class="lk-success-text text text_s24"><div class="lk-success-icon"></div>Спасибо! Договор оферты заключен!</div>');
                }
            })
            .fail(function () {
                console.log('fail');
                $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
                $btn.removeClass('btn_disabled');
            });*/
    });

    // Изменение файлового поля
    $lkAuthorBlock.on('change', '.lk-form-documents input[type="file"]', function () {
        var $this = $(this);

        if($this[0].files[0].size > 5242880){ //Если больше 5 Мбайт
            $this.closest('.fileinput').trigger('clear.fileinput.eksmo');
            $.fancybox.close();
            $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>Файл не должен превышать 5 Мбайт.</p></div>');
        }
    });

    // Нажатие на кнопку "Сохранить" в блоке "Общие данные"
    $lkAuthorBlock.on('click', '.js-lk-common-data-btn:not(.btn_disabled)', function () {
        if($(this).closest('form').validate(validateParams).form()) {
            sendAuthorForm($(this));
        }
    });

    // Нажатие на кнопку "Сохранить" в блоке "Адрес по месту нахождения"
    $lkAuthorBlock.on('click', '.js-lk-address-btn:not(.btn_disabled)', function () {
        if($(this).closest('form').validate(validateParams).form()) {
            sendAuthorForm($(this));
        }
    });

    // Нажатие на кнопку "Сохранить" в блоке "Паспортные данные и ИНН"
    $lkAuthorBlock.on('click', '.js-lk-pasport-data-btn:not(.btn_disabled)', function () {
        if($(this).closest('form').validate(validateParams).form()) {
            sendAuthorForm($(this));
        }
    });

    // Нажатие на кнопку "Сохранить" в блоке "Скан копии документов"
    $lkAuthorBlock.on('click', '.js-lk-documents-btn:not(.btn_disabled)', function () {
        if($(this).closest('form').validate(validateParams).form()) {
            //sendAuthorFileForm($(this));
            sendAuthorForm($(this));
        }
    });

    // Нажатие на кнопку "Сохранить" в блоке "СНИЛС"
    $lkAuthorBlock.on('click', '.js-lk-snils-btn:not(.btn_disabled)', function () {
        if($(this).closest('form').validate(validateParams).form()) {
            sendAuthorForm($(this));
        }
    });

    // Нажатие на кнопку "Сохранить" в блоке "Банковские реквизиты"
    $lkAuthorBlock.on('click', '.js-lk-bank-details-btn:not(.btn_disabled)', function () {
        if($(this).closest('form').validate(validateParams).form()) {
            sendAuthorForm($(this));
        }
    });

    // Результаты отправки форм
    $formsValid.on('eksmoThisAjaxFormSuccess', function (e, message) {
        var $this = $(this);
        console.log('eksmoThisAjaxFormSuccess', message);
        $this.addClass('lk-form-disabled');
        $this.find('input').prop('disabled', true);
        if($this.closest('.lk-manuscript-block').find('form:not(.lk-form-disabled)').length < 1){
            window.location.reload(true);
        }
    });
    $formsValid.on('eksmoThisAjaxFormFail', function (e, message) {
        $.fancybox.close();
        console.log('eksmoThisAjaxFormFail', message);
        if (typeof message === 'string') {
            $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>"' + message + '"</p></div>');
        } else {
            $.fancybox.open('<div><p class="text text_c-gray">Ошибка связи с сервером</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
        }
        $(this).find('.lk-author-submit').removeClass('btn_disabled');
    });

    // раскрытие/закрытие формы предоставления данных для выплаты вознаграждения
    $('.lk-manuscript-accordion-btn').on('click', function () {
        $(this).closest('.lk-manuscript-block').find('.lk-manuscript-accordion-content').toggle(speed, 'linear');
    });

    // Нажатие на информационную иконку на тач устройстве
    if(isTouch()){
        var cInfoPopupShow = 'lk-manuscript-info-popup--show';

        $('.lk-manuscript-info-icon').on('click', function () {
            $(this).closest('.lk-manuscript-info').find('.lk-manuscript-info-popup').addClass(cInfoPopupShow);
        });
        $('.lk-manuscript-info-popup-close').on('click', function () {
            $(this).closest('.lk-manuscript-info').find('.lk-manuscript-info-popup').removeClass(cInfoPopupShow);
        });
    }

    // раскрывающийся текст в попапе
    $('.lk-link-fancybox-text').on('click', function (){
        $.fancybox.close();
        $.fancybox.open({
            type: 'html',
            src: $(this).siblings('.lk-content-fancybox-text').html(),
            touch: false,
        });
    });

    // Отправка формы
    function sendAuthorForm($btn) {
        var $form = $btn.closest('form');
        // var formdata = $form.serializeArray();

        $form.trigger('eksmoCallAjaxFormSubmit');

        $btn.addClass('btn_disabled');

        /*$form.on('eksmoThisAjaxFormSuccess', function (e, message) {
            console.log('eksmoThisAjaxFormSuccess', message);
            $form.addClass('lk-form-disabled');
            $form.find('input').prop('disabled', true);
        });
        $form.on('eksmoThisAjaxFormFail', function (e, message) {
            console.log('eksmoThisAjaxFormFail', message);
            if (typeof message !== undefined) {
                $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>"' + message + '"</p></div>');
            } else {
                $.fancybox.open('<div><p class="text text_c-gray">Ошибка связи с сервером</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
            }
            $btn.removeClass('btn_disabled');
        });*/

        /*$.post($form[0].action, formdata)
            .done(function(data){
                console.log('ajax data before JSONparse', data);
                data = $.parseJSON(data);
                console.log('ajax data', data);

                if(typeof data.error !== 'undefined') {
                    // Ошибка от сервера
                    console.log('error');
                    $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>"' + data.error + '"</p></div>');
                    $btn.removeClass('btn_disabled');
                } else {
                    // Успешная отправка
                    console.log('success');
                    $form.addClass('lk-form-disabled');
                    $form.find('input').prop('disabled', true);
                }
            })
            .fail(function () {
                console.log('fail');
                $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
                $btn.removeClass('btn_disabled');
            });*/
    }

    // Отправка формы с файлами
    /*function sendAuthorFileForm($btn) {
        var $form = $btn.closest('form');
        var $form0 = $form[0];
        var formUrl = $form.data('action');
        var formdata = new FormData($form0);

        console.log('$(this)', $btn, $form, formUrl);

        $btn.addClass('btn_disabled');

        $.ajax({
            url: formUrl,
            data: formdata,
            cache: false,
            contentType: false,
            processData: false,
            timeout: 60000,
            type: 'POST',
            success: function(data){
                var data = $.parseJSON(data);

                if (typeof data.STATUS !== 'undefined' && typeof data.MESSAGE !== 'undefined') {
                    var message = data.MESSAGE;

                    if (data.STATUS) {
                        $form.addClass('lk-form-disabled');
                        $form.find('input').prop('disabled', true);
                    } else {
                        $.fancybox.close();
                        $.fancybox.open('<div>' + message + '</div>');
                    }
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                $.fancybox.close();
                $.fancybox.open('<div>Ошибка связи с сервером</div>');
                $btn.removeClass('btn_disabled');
            }
        });
    }*/

    // Расторжение договора
    $('.lk-manuscript-terminate-contract-link').on('click', function () {
        const $this = $(this);
        const $modalContent = $('.lk-manuscript-modal-terminate-content');

        $modalContent.find('.lk-manuscript-form-terminate-contract-name').text($this.attr('data-contract-name'));
        $modalContent.find('input[name=MANUSCRIPT_ID]').val($this.attr('data-contract-id'));
        $.fancybox.close();
        $.fancybox.open({
            type: 'html',
            src: $modalContent.html(),
            touch: false
        });
    });
}

{ // Оферты авторам
    // заполняем буфер обмена пустым значением при нажатии на printScreen, для запрета скриншотов
    $(document).keyup(function(e){
        if(e.which === 154 || e.which === 44){
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(' ').select();
            document.execCommand("copy");
            $temp.remove();
        }
    });
}

{
    var $indexrActive;
    var $lkQuestions = $('.lk-questions');
    var cQuestionsModeration = 'lk-questions-moderation';
    var sQuestionsModeration = '.' + cQuestionsModeration;
    var cQuestionsAnswered = 'lk-questions-answered';
    var sQuestionsAnswered = '.' + cQuestionsAnswered;
    var cQuestionsDelete = 'lk-questions-delete';
    var sQuestionsDelete = '.' + cQuestionsDelete;
    var sQuestionsCountTabs = '.lk-questions-count-tabs';
    var sQuestions = '.question-answer';
    var sQuestionsInner = '.question-answer_inner';
    var sTabsContainer = '.tabs__containers';
    var cQuestionsAnswerDeleteFull = 'lk-questions-answer-delete_full';
    var cQuestionsDeleteOne = 'lk-questions-answer-delete_one';
    var sQuestionsAuthorInput = '.question-answer__form-author-input';
    var cQuestionsLoad = 'question-answer__load';

    function countQuestionsTabs($this) {
        var $containerActive = $('.tabs__container:eq(' + $indexrActive + ')');
        var $moderationQuestionsCount = $(sQuestionsModeration + ' ' + sQuestionsCountTabs);
        var $answeredQuestionsCount = $(sQuestionsAnswered + ' ' + sQuestionsCountTabs);
        var $deleteQuestionsCount = $(sQuestionsDelete + ' ' + sQuestionsCountTabs);
        var countModeration = parseInt($moderationQuestionsCount.first().text().replace(/[{()}]/g, '')) || 0;
        var countAnswered = parseInt($answeredQuestionsCount.first().text().replace(/[{()}]/g, '')) || 0;
        var countDelete = parseInt($deleteQuestionsCount.first().text().replace(/[{()}]/g, '')) || 0;

        if ($containerActive.hasClass(cQuestionsDelete)) {
            if (!$this.hasClass(cQuestionsDeleteOne)) {
                countAnswered++;
            }
            countDelete = countDelete - 1;
        } else if ($containerActive.hasClass(cQuestionsAnswered)) {
            countDelete = countDelete + 1;
            countAnswered--;
        } else if ($containerActive.hasClass(cQuestionsModeration)) {
            if (!$this.hasClass(cQuestionsDeleteOne)) {
                countAnswered++;
            } else {
                countDelete++;
            }
            countModeration--;
        }

        $moderationQuestionsCount.text('(' + countModeration + ')');
        $answeredQuestionsCount.text('(' + countAnswered + ')');
        $deleteQuestionsCount.text('(' + countDelete + ')');
    }

    $lkQuestions.on('click', '.question-answer__btn-control_answer, .question-answer__btn-control_edits, .question-answer__form-author-btn_cancel', function(){
        $(this).closest(sQuestions).toggleClass('question-answer_form-active');
    });

    $lkQuestions.on('click', '.question-answer__form-author_answer .question-answer__form-author-btn, .lk-questions-answer-delete_one, .lk-questions-answer-delete_all', function(){
        $indexrActive = $('.tabs__container_active').index();
    });

    $lkQuestions.on('eksmoThisAjaxFormSuccess', '.question-answer__form-author_answer', function(e, message, DATA){
        var $this = $(this);
        var $questionAnswerBox = $this.closest(sQuestions);

        $questionAnswerBox.closest(sTabsContainer).find(sQuestionsAnswered + ' .pagenav-ajax__cont').prepend($questionAnswerBox.removeClass('question-answer_orange question-answer_m-left question-answer_form-active'));
        $this.removeClass('ajax-form_success');

        if (typeof DATA.DATA.AVA === 'string' && DATA.DATA.AVA.length) {
            $questionAnswerBox.find('.question-answer_inner .question-answer__ava').attr('style', 'background-image:url('+ DATA.DATA.AVA +')');
        }
        if( typeof DATA.DATA.NAME === 'string') {
            $questionAnswerBox.find(sQuestionsInner + ' .question-answer__name').text(DATA.DATA.NAME);
        }
        if(typeof DATA.DATA.DATE === 'string') {
            $questionAnswerBox.find(sQuestionsInner + ' .question-answer__date').text(DATA.DATA.DATE);
        }
        if(typeof DATA.DATA.REVIEW === 'string') {
            $questionAnswerBox.find(sQuestionsInner + ' .question-answer__text').text(DATA.DATA.REVIEW);
            $questionAnswerBox.find(sQuestionsInner + ' .question-answer__form-author-input').text(DATA.DATA.REVIEW);
        }

        countQuestionsTabs($this);
    });

    $lkQuestions.on('eksmoThisAjaxFormSuccess', '.question-answer__form-author_edits', function(e, message, DATA){
        var $this = $(this);
        var $questionAnswerBox = $this.closest(sQuestionsInner);

        if(typeof DATA.DATA.REVIEW === 'string') {
            $questionAnswerBox.find('.question-answer__text').text(DATA.DATA.REVIEW);
            $questionAnswerBox.find(sQuestionsAuthorInput).val(DATA.DATA.REVIEW);
        }

        $this.removeClass('ajax-form_success');
        $questionAnswerBox.removeClass('question-answer_form-active');
    });

    $lkQuestions.on('click', '.lk-questions-answer-delete_all', function(){
        var $this = $(this);
        var $containerActive = $('.tabs__container:eq(' + $indexrActive + ')');
        var href = $this.closest($lkQuestions).attr('data-delete');
        var $questionAnswerBox = $this.closest('.tabs__container');
        var $deleteQuestionsCount = $(sQuestionsDelete + ' ' + sQuestionsCountTabs);

        $questionAnswerBox.find('.question-answer').addClass(cQuestionsLoad);

        if (typeof href === 'string' && href.length) {
            $.ajax({
                url: href,
                success: function (DATA) {
                    DATA = $.parseJSON(DATA);

                    if ($this.hasClass(cQuestionsAnswerDeleteFull)) {
                        $deleteQuestionsCount.text('(0)');
                        $questionAnswerBox.closest(sTabsContainer).find(sQuestionsDelete + ' .question-answer').remove();
                    } else {
                        $(sQuestionsModeration + ' ' + sQuestionsCountTabs).text('(0)');
                        if (typeof DATA.DATA.COUNT_DELETE === 'string') {
                            $deleteQuestionsCount.text('(' + DATA.DATA.COUNT_DELETE + ')');
                        }
                        $questionAnswerBox.closest(sTabsContainer).find(sQuestionsDelete + ' .pagenav-ajax__cont').prepend($questionAnswerBox.closest('.tabs__container').find(sQuestions + ':not(.question-answer_inner)').removeClass('question-answer_orange question-answer_form-active ' + cQuestionsLoad));
                    }
                    if (!$containerActive.find('.question-answer').length) {
                        $containerActive.find('.pagenav-ajax__nav').remove();
                    }
                }
            });
        }
    });

    $lkQuestions.on('click', '.' + cQuestionsDeleteOne, function(){
        var $this = $(this);
        var href = $this.closest($lkQuestions).attr('data-delete');
        var $questionAnswerBox = $this.closest(sQuestions);
        var id = $questionAnswerBox.find('.question-answer__id').val();

        $questionAnswerBox.addClass(cQuestionsLoad);

        if (typeof id === 'string' && id.length && typeof href === 'string' && href.length) {
            $.ajax({
                url: href,
                data: {id:id},
                success: function() {
                    if ($this.hasClass(cQuestionsAnswerDeleteFull)) {
                        $questionAnswerBox.remove();
                    } else {
                        $questionAnswerBox.closest(sTabsContainer).find(sQuestionsDelete + ' .pagenav-ajax__cont').prepend($questionAnswerBox.removeClass('question-answer_orange question-answer_form-active ' + cQuestionsLoad));
                    }
                    countQuestionsTabs($this);
                }
            });
        }
    });
}

$('.whosale-form').on('eksmoThisAjaxFormSuccess', function () {
    window.scrollTo(0, 0);
    document.location.href = '/personal/0/opt_orders/'
});

$('.menu-lk-item-box .item').on('click', function () {
    if ($(this).text().trim() === 'Оптовым покупателям') {
        eventSender.customYM({
            'click': {
                'click_opt_client': {
                    'link': document.location.href,
                    'title': $('title').text(),
                },
            },
        });
    }
});